import React from 'react'
import { PiClockClockwise, PiLifebuoy, PiMicrosoftTeamsLogo, PiNewspaperClipping, PiQuestion } from 'react-icons/pi'

import { IRightActionBarItem, RightActionBarItemKeys } from '../../types/right-action-bar'
import { allPlatforms } from '../../constants/index'
import { Platform } from '@vacationtracker/shared/types/core-event'
import IntlMessages from '@vacationtracker/shared/components/utils/IntlMessages'

// Right navbar menu items - According to design specifications
const rightActionBarMenuItems: IRightActionBarItem[] = [
  {
    key: RightActionBarItemKeys.MS_BOT_SETUP,
    icon: <PiMicrosoftTeamsLogo />,
    title: <IntlMessages id="containers.topbar.setUpTheBot" /> as unknown as string,
    roles: ['Admin'],
    platform: ['microsoft'],
    badge: 1,
  },
  {
    key: RightActionBarItemKeys.HELP,
    icon: <PiLifebuoy />,
    title: 'Help Center',
    roles: ['Admin', 'Approver', 'User'],
    platform: allPlatforms as Platform[],
  },
  {
    key: RightActionBarItemKeys.DOCS,
    icon: <PiQuestion />,
    title: <IntlMessages id="app.docs" /> as unknown as string,
    roles: ['Admin', 'Approver', 'User'],
    platform: allPlatforms as Platform[],
  },
  {
    key: RightActionBarItemKeys.WHATS_NEW,
    icon: <PiNewspaperClipping />,
    title: <IntlMessages id="app.latestFeatures" /> as unknown as string,
    roles: ['Admin', 'Approver', 'User'],
    platform: allPlatforms as Platform[],
  },
  // Slobodan decided to remove this item from the right navbar because it was not being used and clear enough to have it in the sidebar
  // TODO: Add it back when we improve the announcement feature
  // {
  //   key: RightActionBarItemKeys.ANNOUNCEMENTS,
  //   icon: <PiMegaphone />,
  //   title: <IntlMessages id="containers.topbar.announcement" /> as unknown as string,
  //   roles: ['Admin'],
  //   platform: allPlatforms as Platform[],
  // },
  {
    key: RightActionBarItemKeys.CHANGELOG,
    icon: <PiClockClockwise />,
    title: <IntlMessages id="sidebar.changelog" /> as unknown as string,
    roles: ['Admin', 'Approver', 'User'],
    platform: allPlatforms as Platform[],
    onClick: () => {
      window.open('https://vacationtracker.io/changelog/', '_blank')
    },
  },
]

export default rightActionBarMenuItems
